import { Link } from "react-router-dom";
import { LinkIcon } from "lucide-react";

import { useI18n } from "@/i18n";

const Footer = () => {
  const { t } = useI18n();

  return (
    <footer className="bg-primary text-primary-foreground py-8 px-4">
      <div className="max-w-6xl mx-auto text-center space-y-6">
        <Link
          to="/tableau-de-bord"
          className="inline-flex items-center gap-2 bg-primary-foreground text-primary px-6 py-3 rounded-lg font-semibold hover:bg-primary-foreground/90 transition-colors"
        >
          <LinkIcon className="w-5 h-5" />
          {t("nav.myLinks")}
        </Link>

        <div className="flex flex-wrap justify-center gap-6 text-sm">
          <Link
            to="/"
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            {t("nav.home")}
          </Link>
          <Link
            to="/contact"
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            {t("nav.contact")}
          </Link>
          <Link
            to="/confidentialite"
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            {t("nav.privacy")}
          </Link>
          <Link
            to="/connexion"
            className="hover:text-primary-foreground/80 transition-colors underline underline-offset-4"
          >
            {t("nav.login")}
          </Link>
        </div>

        <p className="text-sm">
          © {new Date().getFullYear()} — {t("home.footer.rights")}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
